<template>
  <div class="make_recommend head-title">
    <div class="justify">
      <div class="title info_tray col-sm-9 col-md-11 col-lg-10">
        <h4>ガチャつくとは？</h4>
        <p>
          ガチャつくは、何回でも回せるオリジナルのガチャをつくれるサイトです。<br>
          テンプレートや自作の画像を組み合わせて、簡単にガチャをつくってみよう！
        </p>
      </div>
    </div>
    <div class="justify mb-3">
      <b-button class="btn-pink" @click="makeLink">ガチャをつくる</b-button>
    </div>
    <div class="justify">
      <div class="justify col-sm-9 col-md-11 col-lg-10">
        <youtube :video-id="'RyUoQ6P5Xfk'" ref="youtube"></youtube>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router'

export default {
  methods: {
    makeLink() {
      router.push('/make');
    }
  }
}
</script>

<style scoped>
@import '../css/common.css';

.make_recommend {
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 0px;
}
.make_recommend > div > .title {
  background-color: rgb(246, 238, 241);
  padding: 10px;
  margin-bottom: 1em;
  border-radius: 10px;
}
.make_recommend > div > .title > h4 {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 800;
}
.make_recommend > div > .title > p {
  font-size: 14px;
  margin-bottom: 0px;
}
.btn-pink {
  width: 180px;
}
</style>